export const GET_PRICING_METHODS_QUERY = `
  query GetPricingMethods($where: pricing_methods_bool_exp = {}) {
    pricing_methods(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const GET_PRICING_METHOD_BY_ID_QUERY = `
  query GetPricingMethodById($id: Int!) {
    pricing_methods_by_pk(id: $id) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`; 